import React from 'react';
import { ParticleBackground } from './components/ParticleBackground';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Benefits } from './components/Benefits';
import { Portfolio } from './components/Portfolio';
import { Process } from './components/Process';
import { Authority } from './components/Authority';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="relative min-h-screen text-white font-sans selection:bg-neon-blue/30 selection:text-white" data-id="element-0">
      <ParticleBackground data-id="element-1" />
      <div className="relative" style={{
      zIndex: 1
    }} data-id="element-2">
        <Navbar data-id="element-3" />
        <main data-id="element-4">
          <Hero data-id="element-5" />
          <Problem data-id="element-6" />
          <Benefits data-id="element-7" />
          <Portfolio data-id="element-8" />
          <Process data-id="element-9" />
          <Authority data-id="element-10" />
          <Testimonials data-id="element-11" />
          <FAQ data-id="element-12" />
          <FinalCTA data-id="element-13" />
        </main>
        <Footer data-id="element-14" />
      </div>
    </div>;
}